export const REPORT_AS_VISIT = 1;
export const REPORT_AS_SERVICE = 2;

export const REPORT_BY_NEW = 1;
export const REPORT_BY_RECURRUNG = 2;
export const REPORT_BY_DUPLICATED = 3;
export const REPORT_BY_UNDUPLICATED = 4;

export const NEW_BY_CALENDAR_YEAR = 1;
export const NEW_BY_FISCAL_YEAR = 2;
export const NEW_BY_MONTH = 3;
export const NEW_BY_EVER = 4;
export const NEW_BY_SELECTED_DATE = 5;

export const RESULT_BY_DAY = 1;
export const RESULT_BY_WEEK = 2;
export const RESULT_BY_MONTH = 3;
export const RESULT_BY_YEAR = 4;

export const REPORT_AS_LABELS = {
  [REPORT_AS_VISIT]: 'Physical Visit',
  [REPORT_AS_SERVICE]: 'Tracking Method Visit'
};

export const REPORT_BY_LABELS = {
  [REPORT_BY_NEW]: 'New',
  [REPORT_BY_RECURRUNG]: 'Returning',
  [REPORT_BY_DUPLICATED]: 'Total',
  [REPORT_BY_UNDUPLICATED]: 'Unique'
};

export const NEW_BY_LABELS = {
  [NEW_BY_CALENDAR_YEAR]: 'New This Calendar Year',
  [NEW_BY_FISCAL_YEAR]: 'New This Fiscal Year',
  [NEW_BY_MONTH]: 'New This Month',
  [NEW_BY_EVER]: 'New Ever',
  [NEW_BY_SELECTED_DATE]: 'New By Date Range'
};

export const RESULT_BY_LABELS = {
  [RESULT_BY_DAY]: 'Day',
  [RESULT_BY_WEEK]: 'Week',
  [RESULT_BY_MONTH]: 'Month',
  [RESULT_BY_YEAR]: 'Year'
};
